import React from 'react'
import { withTranslation } from 'react-i18next'
import { PageHeading } from '../components/Fragments'
import { publicationList } from '../data/archive'

const ExpandedArticles = ({ t, year, part, cover, filePath, articles }) => {
  return (
    <>
      <div className="uk-margin-medium-top uk-margin-medium-bottom" data-uk-grid>
        <div className="uk-width-1-5@s">
          <a className="uk-text-center uk-link-muted" href={filePath} target="_blank" rel="noreferrer">
            <img className="uk-border-rounded" src={`collections/${cover}.jpg`} alt="hero-cover" />
          </a>
        </div>
        <div className="uk-width-4-5@s">
          <div className="uk-card uk-card-default uk-card-body uk-border-rounded">
            <span className='uk-label'>JAS {year}</span>
            {articles && articles.map(({ id, author, title, path }) => <div key={id}>
              <span className='article'>
                <span className="author">{author?.toUpperCase()}</span> - <a href={`collections/issues/${year}/${path}.pdf`}>{t(`articles.${id}`)?.toUpperCase()}</a>
              </span>
            </div>)}
          </div>
        </div>
      </div>
    </>
  )
}

function Archive({ t }) {
  return (
    <>
      <PageHeading pageTitle='menu.archive' acronym='acronym' researchCenter='cavas_research_center' />
      {publicationList.map(issue => <ExpandedArticles key={issue.year} {...issue} t={t} />)}
    </>
  )
}

export default withTranslation()(Archive)
